import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../uicomponentcss';

export interface PlayerComponentCSSStyle extends UIComponentCSSStyle
{
    getPlayDivCSSStyle(): object;
    getPlayIconCSSStyle(): object;
}

export class PlayerComponentCSSStyleImpl extends UIComponentCSSStyleImpl implements PlayerComponentCSSStyle
{
    getPlayDivCSSStyle(): object 
    {
        return {
            display: "flex",
            textAlign: "center",
            alignItems: 'center', 
            justifyContent: 'center', 
            position: "absolute",
            marginTop: "110px",
            marginLeft: "90px",
            marginRight: "90px",
            cursor: "pointer",
            width: "40px",
            height: "40px"
        };
    }

    getPlayIconCSSStyle(): object 
    {
        return {
            cursor: "pointer",
            height: "40px",
            width: "40px",
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/player/playercss.tsx